import cookie from 'cookie';

// Constants
import { DOMAIN_COMPANY_MAP, SSO_CDH_COMPANY_KEY } from '../Constants/Constants';

const sanitizeCookieValue = (value: string | undefined): string | null => {
    if (!value || value === 'undefined' || value === 'null' || value.trim() === '') {
        return null;
    }
    return value;
};

const getEnvironment = (hostname: string): keyof typeof DOMAIN_COMPANY_MAP => {
    if (hostname.includes('.sit.')) return 'SIT';
    if (hostname.includes('.uat.')) return 'UAT';
    return 'PROD';
};

const getReferringCompanyFromHostname = (): string => {
    const hostname = window.location.hostname;
    const env = getEnvironment(hostname);
    const envMap = DOMAIN_COMPANY_MAP[env] as Record<string, string>;

    if (Object.prototype.hasOwnProperty.call(envMap, hostname)) {
        return envMap[hostname];
    }

    return 'currenciesdirect';
};

export const getReferringCompany = (): string => {
    const cookies = cookie.parse(document.cookie);
    const ssoReferringCompany: string = cookies[SSO_CDH_COMPANY_KEY];
    const cdhCompany: string = cookies.cdhCompany;

    console.log('getReferringCompany - cdhCompany:', cdhCompany); //temporary
    console.log('getReferringCompany - ssoReferringCompany:', ssoReferringCompany); //temporary

    const sanitizedSSO = sanitizeCookieValue(ssoReferringCompany);
    const sanitizedCDH = sanitizeCookieValue(cdhCompany);

    const result = sanitizedSSO ?? sanitizedCDH ?? getReferringCompanyFromHostname();
    console.log('getReferringCompany - sanitized result:', result); //temporary

    return result;
};

export const referringCompany: string = getReferringCompany();
